'use client';

import { useContentfulInspectorMode } from '@contentful/live-preview/react';
import { FC, ReactNode } from 'react';
import { TPosition } from '@/types/types';
import classNames from 'classnames';

type TileHeaderProps = {
    id?: string;
    title?: string | ReactNode;
    subtitle?: string | ReactNode;
    isDarkMode?: boolean;
    titlePosition?: TPosition;
    subtitlePosition?: TPosition;
};

const TileHeader: FC<TileHeaderProps> = ({
    id,
    title,
    subtitle,
    isDarkMode,
    titlePosition = 'Center',
    subtitlePosition = 'Center',
}) => {
    const inspectorProps = useContentfulInspectorMode({ entryId: id });
    return (
        <>
            {typeof subtitle === 'string' ? (
                <h3
                    className={classNames(
                        'tw-pb-1 tw-font-light tw-text-center tw-leading-[16px] tw-uppercase tw-text-sm tw-font-gotham-medium',
                        {
                            'tw-text-pink1': !isDarkMode,
                            'tw-text-textPaleGreen': isDarkMode,
                            'tw-text-center md:tw-text-start': titlePosition === 'Left',
                            'tw-text-center': titlePosition === 'Center',
                            'tw-text-end': titlePosition === 'Right',
                        },
                    )}
                    {...inspectorProps({ fieldId: 'subtitle' })}
                >
                    {subtitle}
                </h3>
            ) : (
                <span {...inspectorProps({ fieldId: 'subtitle' })}>{subtitle}</span>
            )}

            {typeof title === 'string' ? (
                <h2
                    className={classNames(
                        'tw-text-center tw-font-light tw-text-[26px] lg:tw-text-[32px] tw-leading-[36px] tw-font-gotham-bold',
                        {
                            'tw-text-textBlue': !isDarkMode,
                            'tw-text-white': isDarkMode,
                            'tw-text-center md:tw-text-start': subtitlePosition === 'Left',
                            'tw-text-center': subtitlePosition === 'Center',
                            'tw-text-end': subtitlePosition === 'Right',
                        },
                    )}
                    {...inspectorProps({ fieldId: 'title' })}
                >
                    {title}
                </h2>
            ) : (
                <span {...inspectorProps({ fieldId: 'title' })}>{title}</span>
            )}
        </>
    );
};

export default TileHeader;
